import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../utils/api'; // 環境に合わせてパスを調整してください

function PrivateImage({ filename, className, alt = "Profile", style = {} }) {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 画像ファイル名がない場合は何もしない
    if (!filename) {
      setImageSrc(null);
      return;
    }

    let objectUrl = null;

    const fetchSecureImage = async () => {
      setLoading(true);
      try {
        // 🌟 バックエンドのGET APIを叩く（/auth/me/image/{filename}）
        // ※ apiFetchのベースURLに合わせて調整してください
        const res = await apiFetch(`/auth/me/image/${filename}`);

        if (res.ok) {
          const blob = await res.blob(); // 画像をバイナリとして受け取る
          objectUrl = URL.createObjectURL(blob); // ブラウザ用の一時URLに変換
          setImageSrc(objectUrl);
        } else {
          setImageSrc(null);
        }
      } catch (error) {
        console.error("画像の取得に失敗しました", error);
        setImageSrc(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSecureImage();

    // コンポーネントが破棄される時にメモリを解放する
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [filename]);

  const combinedStyle = { objectFit: 'cover', ...style };

  if (loading) {
    return (
      <div className={`${className} d-flex align-items-center justify-content-center bg-light text-muted`}>
        <i className="fa fa-spinner fa-spin"></i>
      </div>
    );
  }

  // 画像があればimgタグ、なければアイコンを表示
  return imageSrc ? (
    <img src={imageSrc} className={className} alt={alt} style={combinedStyle} />
  ) : (
    <img src="/assets/img/user/anonymous.jpg" className={className} alt={alt} style={combinedStyle} />
  );
}

export default PrivateImage;